module.exports = __webpack_public_path__ + "img/train2.79685c3a.png";